export const optionsConstant = {
  parentOptions: {
    GENERAL: { id: 1, name: 'GENERAL' },
    STANDARD: { id: 2, name: 'STANDARD' },
    ACTION: { id: 3, name: 'ACTION' },
    ETC: { id: 4, name: 'ETC' },
    ADULTS_ONLY: { id: 5, name: 'ADULTS_ONLY' }
  },
  childOptions: {
    //GENERAL
    wholeGenderNumber: { id: 1, name: '총 인원수', parentId: 1 },
    maleNumber: { id: 2, name: '남성 인원수', parentId: 1 },
    femaleNumber: { id: 3, name: '여성 인원수', parentId: 1 },
    shot: { id: 4, name: '샷 구분', parentId: 1 },
    angleFirst: { id: 25, name: '앵글 1', parentId: 1 },
    angleSecond: { id: 26, name: '앵글 2', parentId: 1 },

    //STANDARD
    bodyPart: { id: 9, name: '신체부위', parentId: 2 },
    facialExpression: { id: 10, name: '표정', parentId: 2 },
    deforme: { id: 13, name: '데포르메', parentId: 2 },
    backgroundCut: { id: 27, name: '배경컷', parentId: 2 },
    directed: { id: 5, name: '연출', parentId: 2 },
    ageRange: { id: 6, name: '연령대', parentId: 2 },
    mainMotionPart: { id: 9, name: '중심동작부위', parentId: 2 },
    postureCategory: { id: 28, name: '동작구분', parentId: 2 },
    skinship: { id: 8, name: '스킨십', parentId: 2 },

    //ACTION
    action: { id: 14, name: '액션', parentId: 3 },

    //ETC
    etc: { id: 15, name: '기타', parentId: 4 },

    //ADULTS_ONLY
    femaleBody: { id: 16, name: '여체', parentId: 5 },
    sexualPosition: { id: 18, name: '체위', parentId: 5 },
    sexualBodyPart: { id: 22, name: '신체 부위', parentId: 5 }
  }
};
